/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ accepted: NonNullable<unknown>, total: NonNullable<unknown> }} Draft_Accept_PartialInputs */

const en_us2_draft_accept_partial = /** @type {(inputs: Draft_Accept_PartialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Accept ${i?.accepted} of ${i?.total}`)
};

const pt_br2_draft_accept_partial = /** @type {(inputs: Draft_Accept_PartialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aceitar ${i?.accepted} de ${i?.total}`)
};

const es_419_draft_accept_partial = /** @type {(inputs: Draft_Accept_PartialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aceptar ${i?.accepted} de ${i?.total}`)
};

const pt_pt2_draft_accept_partial = /** @type {(inputs: Draft_Accept_PartialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aceitar ${i?.accepted} de ${i?.total}`)
};

const fr_fr2_draft_accept_partial = /** @type {(inputs: Draft_Accept_PartialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Accepter ${i?.accepted} sur ${i?.total}`)
};

const de_de2_draft_accept_partial = /** @type {(inputs: Draft_Accept_PartialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.accepted} von ${i?.total} übernehmen`)
};

const it_it2_draft_accept_partial = /** @type {(inputs: Draft_Accept_PartialInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Accetta ${i?.accepted} di ${i?.total}`)
};

/**
* | output |
* | --- |
* | "Accept {accepted} of {total}" |
*
* @param {Draft_Accept_PartialInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_accept_partial = /** @type {((inputs: Draft_Accept_PartialInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Accept_PartialInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_accept_partial(inputs)
	if (locale === "es-419") return es_419_draft_accept_partial(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_accept_partial(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_accept_partial(inputs)
	if (locale === "de-DE") return de_de2_draft_accept_partial(inputs)
	if (locale === "it-IT") return it_it2_draft_accept_partial(inputs)
	return en_us2_draft_accept_partial(inputs)
});
export { draft_accept_partial as "draft.accept_partial" }